module.exports = __webpack_public_path__ + "static/media/blog-post.3.dc8bb1a1.md";